// import React, { useState, useEffect } from 'react'; // Added useEffect
// import { motion, AnimatePresence } from 'framer-motion';
// // Import Toast components
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { 
//     Phone, Mail, MapPin, Send, MessageSquare, 
//     Clock, CheckCircle2, Linkedin, Twitter, 
//     Facebook, Instagram, Loader2, Sparkles, Globe, LayoutDashboard, Zap, Users, Shield, FileText, Settings, TrendingUp, Bot, BarChart3,
//     ChevronDown,
//     RefreshCcw // Added for captcha refresh
// } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// import Image1 from "../../assets/whatsapp.jpeg";
// import { API_URL } from '../../../Constants';

// // --- Contact Helper Components ---
// const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
// };

// const itemVariants = {
//     hidden: { opacity: 0, y: 15 },
//     visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
// };

// const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
//     <div className="flex flex-col space-y-1.5 text-left">
//         <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//         <input
//             type={type}
//             name={name}
//             value={value}
//             onChange={onChange}
//             placeholder={placeholder}
//             required={required}
//             readOnly={readOnly}
//             className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
//                 readOnly 
//                 ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed pointer-events-none select-none" 
//                 : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
//             }`}
//         />
//     </div>
// );

// const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
//     <div className="flex flex-col space-y-1.5 text-left">
//         <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//         <textarea
//             name={name}
//             value={value}
//             onChange={onChange}
//             rows="4"
//             placeholder={placeholder}
//             required={required}
//             className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
//         />
//     </div>
// );

// const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
//     <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
//         <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
//             <Icon className="text-white w-4 h-4" />
//         </div>
//         <div className="text-left">
//             <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
//             <p className="text-white text-base font-bold leading-tight">{content}</p>
//             {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
//         </div>
//     </motion.div>
// );

// const Whatsapp = () => {
//     const navigate = useNavigate();

//     // --- Form Logic: Updated Keys to fullName and phoneNumber ---
//     const [formState, setFormState] = useState({ 
//         fullName: '', 
//         email: '', 
//         phoneNumber: '', 
//         subject: 'WhatsApp API Inquiry', 
//         message: '' 
//     });
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [isSubmitting, setIsSubmitting] = useState(false);

//     // --- CAPTCHA LOGIC ---
//     const [captchaText, setCaptchaText] = useState('');
//     const [userInputCaptcha, setUserInputCaptcha] = useState('');

//     const generateCaptcha = () => {
//         const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
//         let result = "";
//         for (let i = 0; i < 6; i++) {
//             result += chars.charAt(Math.floor(Math.random() * chars.length));
//         }
//         setCaptchaText(result);
//         setUserInputCaptcha('');
//     };

//     useEffect(() => {
//         generateCaptcha();
//     }, []);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         if (name === 'phoneNumber') {
//             const cleaned = value.replace(/\D/g, ''); 
//             if (cleaned.length <= 10) {
//                 setFormState({ ...formState, [name]: cleaned });
//             }
//             return;
//         }
//         setFormState({ ...formState, [name]: value });
//     };

//     const validateForm = () => {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         const phoneRegex = /^\d{10}$/;

//         if (!emailRegex.test(formState.email)) {
//             toast.error("Please enter a valid email address with '@'");
//             return false;
//         }
//         if (!phoneRegex.test(formState.phoneNumber)) {
//             toast.error("Phone number must be exactly 10 digits");
//             return false;
//         }
//         if (formState.fullName.trim().length < 2) {
//             toast.error("Please enter your full name");
//             return false;
//         }
//         if (userInputCaptcha.toUpperCase() !== captchaText) {
//             toast.error("Incorrect security code. Please try again.");
//             generateCaptcha();
//             return false;
//         }
//         return true;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!validateForm()) return;

//         setIsSubmitting(true);
//         try {
//             const response = await fetch(`${API_URL}/api/public/contact`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(formState),
//             });

//             const result = await response.json();

//             if (response.ok && result.success) {
//                 setIsSubmitted(true);
//                 toast.success(result.message || "Request sent successfully!");
//                 setFormState({ 
//                     fullName: '', 
//                     email: '', 
//                     phoneNumber: '', 
//                     subject: 'WhatsApp API Inquiry', 
//                     message: '' 
//                 });
//                 generateCaptcha();
//             } else {
//                 toast.error(result.message || "Something went wrong. Please try again.");
//                 generateCaptcha();
//             }
//         } catch (error) { 
//             console.error(error); 
//             toast.error("Failed to connect to the server.");
//         } 
//         finally { setIsSubmitting(false); }
//     };

//     const bgPuzzleStyle = {
//         backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
//         backgroundSize: '30px 30px',
//     };

//     // Features Data
//     const features = [
//         { title: "API Integration", description: "Easy integration with your systems.", icon: Globe, bgColor: "bg-[#00C853]", delay: 0.1 },
//         { title: "Real-time Dashboard", description: "Monitor your activities in real-time.", icon: LayoutDashboard, bgColor: "bg-[#0091EA]", delay: 0.2 },
//         { title: "Message Templates", description: "Create and manage message templates.", icon: MessageSquare, bgColor: "bg-[#6200EA]", delay: 0.3 },
//         { title: "Bulk Messaging", description: "Send messages to multiple contacts.", icon: Zap, bgColor: "bg-[#FF6D00]", delay: 0.4 },
//         { title: "CRM Features", description: "Manage customer relationships effectively.", icon: Users, bgColor: "bg-[#00BFA5]", delay: 0.5 },
//         { title: "Secure Platform", description: "Built with security in mind.", icon: Shield, bgColor: "bg-[#00C853]", delay: 0.6 }
//     ];

//     // Integration Hub Data
//     const integrationFeatures = [
//         { icon: <MessageSquare className="w-5 h-5 md:w-6 md:h-6" />, title: "Auto Replies", linear: "from-blue-500 to-cyan-500", position: "left" },
//         { icon: <FileText className="w-5 h-5 md:w-6 md:h-6" />, title: "Templates", linear: "from-purple-500 to-pink-500", position: "left" },
//         { icon: <Settings className="w-5 h-5 md:w-6 md:h-6" />, title: "WhatsApp Config", linear: "from-green-500 to-emerald-500", position: "left" },
//         { icon: <TrendingUp className="w-5 h-5 md:w-6 md:h-6" />, title: "Scale Business", linear: "from-orange-500 to-amber-500", position: "left" },
//         { icon: <Send className="w-5 h-5 md:w-6 md:h-6" />, title: "Bulk Messaging", linear: "from-indigo-500 to-purple-500", position: "left" },
//         { icon: <Bot className="w-5 h-5 md:w-6 md:h-6" />, title: "AI Support", linear: "from-violet-500 to-purple-500", position: "right" },
//         { icon: <Clock className="w-5 h-5 md:w-6 md:h-6" />, title: "24/7 Available", linear: "from-cyan-500 to-blue-500", position: "right" },
//         { icon: <Zap className="w-5 h-5 md:w-6 md:h-6" />, title: "Instant Responses", linear: "from-yellow-500 to-orange-500", position: "right" },
//         { icon: <BarChart3 className="w-5 h-5 md:w-6 md:h-6" />, title: "Analytics", linear: "from-pink-500 to-rose-500", position: "right" },
//         { icon: <Shield className="w-5 h-5 md:w-6 md:h-6" />, title: "Security", linear: "from-emerald-500 to-teal-500", position: "right" },
//     ];

//     return (
//         <div className="bg-[#EEF2FC] min-h-screen font-sans overflow-x-hidden">
//             <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
            
//             {/* SECTION 1: HERO */}
//             <div className="relative overflow-hidden">
//                 <div className="absolute inset-0 overflow-hidden pointer-events-none">
//                     <motion.div
//                         className="absolute -top-24 -right-24 w-[400px] h-[400px] bg-gradient-to-br from-green-400/20 via-emerald-400/15 to-teal-400/10 rounded-full blur-3xl"
//                         animate={{ scale: [1, 1.1, 1], opacity: [0.3, 0.5, 0.3] }}
//                         transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
//                     />
//                 </div>

//                 <section className="relative w-full min-h-[80vh] flex items-center overflow-hidden py-12 md:py-20 px-6">
//                     <div className="max-w-[1400px] mx-auto w-full relative z-10">
//                         <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
//                             <div className="flex flex-col items-start text-left order-2 lg:order-1 lg:pl-16">
//                                 <div className="inline-block mb-6 rotate-[-2deg]">
//                                     <span className="inline-flex items-center gap-2 px-4 md:px-5 py-2 bg-lime-400 border-[3px] border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] rounded-md cursor-default">
//                                         <Sparkles className="w-4 h-4 text-black fill-white" />
//                                         <span className="text-xs md:text-sm font-black text-black tracking-wide uppercase">
//                                             Enterprise WhatsApp Business API
//                                         </span>
//                                     </span>
//                                 </div>

//                                 <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
//                                     Turn WhatsApp into <br />
//                                     <span className="relative inline-block">
//                                         <span className="font-extrabold bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 bg-clip-text text-transparent">a revenue engine</span>
//                                         <motion.div className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-full" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ delay: 1, duration: 0.8 }} />
//                                     </span>
//                                     <span className="text-slate-900"> for your business</span>
//                                 </h1>
//                                 <p className="text-lg md:text-xl text-slate-700 max-w-xl leading-relaxed mb-10">
//                                     Transform customer engagement with <span className="font-bold text-slate-950">NIPANE</span>'s intelligent WhatsApp platform. AI-powered, blazing-fast, and built for enterprise.
//                                 </p>
//                                 <a 
//                                     href="#contact-start" 
//                                     className="inline-flex items-center gap-2 px-6 py-4 bg-slate-900 text-white text-lg font-medium rounded-xl transition-all hover:scale-105 shadow-xl active:scale-95"
//                                 >
//                                     Start Free Trial
//                                     <ChevronDown className="w-5 h-5 animate-bounce" />
//                                 </a>
//                             </div>
//                             <motion.div initial={{ opacity: 0, x: 50, scale: 0.9 }} animate={{ opacity: 1, x: 0, scale: 1 }} transition={{ duration: 1, delay: 0.3 }} className="relative order-1 lg:order-2 flex justify-center lg:justify-end">
//                                 <div className="absolute inset-0 bg-gradient-to-br from-green-400/20 to-emerald-400/20 rounded-2xl blur-3xl scale-110"></div>
//                                 <motion.div animate={{ y: [0, -15, 0] }} transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }} className="relative z-10 w-full max-w-[600px]">
//                                     <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white/80">
//                                         <img src={Image1} alt="WhatsApp" className="w-full h-auto object-cover" />
//                                     </div>
//                                 </motion.div>
//                             </motion.div>
//                         </div>
//                     </div>
//                 </section>
//             </div>

//             {/* SECTION 2: FEATURES GRID */}
//             <section className="pt-10 pb-20 px-6 bg-[#EEF2FC]">
//                 <div className="max-w-[1200px] mx-auto text-center">
//                     <div className="mb-16">
//                         <h2 className="text-3xl md:text-5xl font-semibold text-slate-900 mb-4">
//                             Powerful{" "}
//                             <span className="relative inline-block">
//                                 <span className="text-emerald-600">features</span>
//                                 <motion.div className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-full" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={{ delay: 0.4, duration: 0.8 }} />
//                             </span>
//                         </h2>
//                         <p className="text-slate-700 text-lg md:text-xl font-medium">Everything you need to manage WhatsApp business communications</p>
//                     </div>
//                     <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
//                         {features.map((feature, index) => (
//                             <motion.div key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: feature.delay }} className="group relative p-8 rounded-[2rem] bg-[#D0DCF2] border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden">
//                                 <div className={`w-14 h-14 rounded-2xl ${feature.bgColor} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}><feature.icon className="w-7 h-7 text-white" /></div>
//                                 <h3 className="text-2xl font-bold text-slate-900 mb-3 leading-tight">{feature.title}</h3>
//                                 <p className="text-slate-600 text-base leading-relaxed">{feature.description}</p>
//                             </motion.div>
//                         ))}
//                     </div>
//                 </div>
//             </section>

//             {/* SECTION 3: INTEGRATION HUB */}
//             <section className="py-12 px-6 bg-[#EEF2FC] relative overflow-hidden">
//                 <div className="max-w-[1400px] mx-auto relative z-10">
//                     <div className="text-center mb-16 px-4">
//                         <h2 className="text-3xl md:text-5xl font-semibold text-slate-900 mb-4 tracking-tight">
//                             Everything you need,{" "}
//                             <span className="relative inline-block">
//                                 <span className="bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">all in one place</span>
//                                 <motion.div className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-full" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={{ delay: 0.4, duration: 0.8 }} />
//                             </span>
//                         </h2>
//                         <p className="text-slate-600 text-lg md:text-xl font-normal max-w-2xl mx-auto">NIPANE connects all your WhatsApp business tools seamlessly into a single ecosystem.</p>
//                     </div>

//                     <div className="relative min-h-[500px] lg:min-h-[600px] flex items-center justify-center">
//                         <motion.div initial={{ scale: 0 }} whileInView={{ scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8, type: "spring" }} className="relative z-20">
//                             <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-emerald-500 rounded-3xl blur-2xl opacity-40" />
//                             <motion.div className="relative bg-gradient-to-br from-green-500 to-emerald-600 rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-white" whileHover={{ scale: 1.05 }}>
//                                 <MessageSquare className="w-10 h-10 md:w-16 md:h-16 text-white mx-auto mb-4" />
//                                 <h3 className="text-2xl md:text-4xl font-black text-white text-center tracking-tighter">NIPANE</h3>
//                             </motion.div>
                            
//                             {[1, 2, 3].map((ring, idx) => (
//                                 <motion.div key={ring} className="absolute inset-0 border-2 border-green-400 rounded-3xl" animate={{ scale: [1, 1.3 + idx * 0.2, 1], opacity: [0.6, 0, 0.6] }} transition={{ duration: 4, repeat: Infinity, delay: idx * 0.5, ease: "easeOut" }} />
//                             ))}
//                         </motion.div>

//                         <div className="hidden lg:block absolute inset-0 w-full h-full">
//                             <div className="absolute left-[12%] top-1/2 -translate-y-1/2 space-y-6">
//                                 {integrationFeatures.filter(f => f.position === "left").map((feature, idx) => (
//                                     <motion.div key={idx} initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }} whileHover={{ scale: 1.05, x: 10 }} className="flex items-center gap-4 bg-white p-4 rounded-2xl shadow-xl border border-slate-100 min-w-[260px] group cursor-default">
//                                         <div className={`p-3 rounded-xl bg-gradient-to-br ${feature.linear} text-white shadow-lg transition-transform group-hover:rotate-12`}>{feature.icon}</div>
//                                         <h4 className="font-bold text-slate-800 text-lg">{feature.title}</h4>
//                                     </motion.div>
//                                 ))}
//                             </div>
//                             <div className="absolute right-[12%] top-1/2 -translate-y-1/2 space-y-6">
//                                 {integrationFeatures.filter(f => f.position === "right").map((feature, idx) => (
//                                     <motion.div key={idx} initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }} whileHover={{ scale: 1.05, x: -10 }} className="flex items-center gap-4 bg-white p-4 rounded-2xl shadow-xl border border-slate-100 min-w-[260px] group cursor-default">
//                                         <div className={`p-3 rounded-xl bg-gradient-to-br ${feature.linear} text-white shadow-lg transition-transform group-hover:-rotate-12`}>{feature.icon}</div>
//                                         <h4 className="font-bold text-slate-800 text-lg">{feature.title}</h4>
//                                     </motion.div>
//                                 ))}
//                             </div>
//                         </div>

//                         <div className="lg:hidden grid grid-cols-1 sm:grid-cols-2 gap-4 mt-20 w-full max-w-2xl">
//                             {integrationFeatures.map((feature, idx) => (
//                                 <motion.div key={idx} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-md border border-slate-100">
//                                     <div className={`p-2 rounded-lg bg-gradient-to-br ${feature.linear} text-white shadow-sm`}>{feature.icon}</div>
//                                     <span className="font-bold text-slate-800 text-sm">{feature.title}</span>
//                                 </motion.div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* REQUEST A DEMO SECTION */}
//             <section id="contact-start" className="py-16 relative overflow-hidden">
//                 <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
//                 <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
                
//                 <div className="container mx-auto px-4 relative z-10">
//                     <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
//                         {/* LEFT SIDE */}
//                         <motion.div variants={itemVariants} className="space-y-8">
//                             <div>
//                                 <div className="inline-flex items-center gap-2 mb-2">
//                                     <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
//                                     <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">Get in Touch</span>
//                                 </div>
//                                 <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">Request a <span className="text-[#F46653]"> WhatsApp Demo</span></h2>
//                                 <p className="text-white/70 text-base leading-relaxed text-left">Our dedicated support team is available 24/7 to assist with your business communication needs.</p>
//                             </div>

//                             <div className="space-y-3">
//                                 <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
//                                 <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
//                                 <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
//                                 <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
//                             </div>

//                             <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
//                                 <p className="text-white text-base font-bold mb-2 text-left">Connect With Us -</p>
//                                 <div className="flex gap-3">
//                                     {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
//                                         <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white group transition-all">
//                                             <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
//                                         </motion.a>
//                                     ))}
//                                 </div>
//                             </motion.div>
//                         </motion.div>

//                         {/* RIGHT SIDE - FORM */}
//                         <motion.div variants={itemVariants}>
//                             <div className="bg-white rounded-3xl shadow-2xl p-8">
//                                 <AnimatePresence mode="wait">
//                                     {isSubmitted ? (
//                                         <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-12">
//                                             <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
//                                             <h3 className="text-3xl font-bold text-gray-800 mb-4">Request Sent!</h3>
//                                             <p className="text-gray-600 mb-8">Our team will get back to you within 2 hours to schedule your demo.</p>
//                                             <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl hover:bg-[#09333c] transition-colors">Send Another</button>
//                                         </motion.div>
//                                     ) : (
//                                         <motion.div key="form">
//                                             <div className="flex items-center gap-3 mb-6">
//                                                 <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
//                                                 <div className="text-left">
//                                                     <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
//                                                     <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
//                                                 </div>
//                                             </div>
//                                             <form onSubmit={handleSubmit} className="space-y-5">
//                                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                                                     <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
//                                                     <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
//                                                 </div>
                                                
//                                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                                                     <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
//                                                     <InputField 
//                                                         label="Subject" 
//                                                         name="subject" 
//                                                         value="WhatsApp API Inquiry" 
//                                                         readOnly={true} 
//                                                     />
//                                                 </div>

//                                                 <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

//                                                 {/* --- ADDED CAPTCHA FIELD --- */}
//                                                 <div className="flex flex-col space-y-1.5 pt-2 text-left">
//                                                     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
//                                                     <div className="flex items-center gap-4">
//                                                         <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
//                                                             <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
//                                                                 {captchaText}
//                                                             </span>
//                                                         </div>
//                                                         <button 
//                                                             type="button" 
//                                                             onClick={generateCaptcha} 
//                                                             className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                                                             title="Refresh Code"
//                                                         >
//                                                             <RefreshCcw className="w-5 h-5 text-gray-500" />
//                                                         </button>
//                                                         <div className="flex-1">
//                                                             <input
//                                                                 type="text"
//                                                                 placeholder="Enter code"
//                                                                 value={userInputCaptcha}
//                                                                 onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
//                                                                 className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
//                                                                 required
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 </div>

//                                                 <div className="flex items-center justify-between pt-2">
//                                                     <motion.button 
//                                                         disabled={isSubmitting || userInputCaptcha.length < 6} 
//                                                         whileHover={{ scale: isSubmitting ? 1 : 1.02 }} 
//                                                         whileTap={{ scale: isSubmitting ? 1 : 0.98 }} 
//                                                         type="submit" 
//                                                         className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//                                                     >
//                                                         {isSubmitting ? (
//                                                             <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
//                                                         ) : (
//                                                             <>Send Message <Send className="w-5 h-5" /></>
//                                                         )}
//                                                     </motion.button>
//                                                 </div>
//                                             </form>
//                                         </motion.div>
//                                     )}
//                                 </AnimatePresence>
//                             </div>
//                         </motion.div>
//                     </motion.div>
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default Whatsapp;






import React, { useState, useEffect } from 'react'; // Added useEffect
import { motion, AnimatePresence } from 'framer-motion';
// Import Toast components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { 
    Phone, Mail, MapPin, Send, MessageSquare, 
    Clock, CheckCircle2, Linkedin, Twitter, 
    Facebook, Instagram, Loader2, Sparkles, Globe, LayoutDashboard, Zap, Users, Shield, FileText, Settings, TrendingUp, Bot, BarChart3,
    ChevronDown,
    RefreshCcw // Added for captcha refresh
} from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

import Image1 from "../../assets/whatsapp.jpeg";
import { API_URL } from '../../../Constants';

// --- Contact Helper Components ---
const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
};

const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
};

const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
    <div className="flex flex-col space-y-1.5 text-left">
        <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            readOnly={readOnly}
            className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
                readOnly 
                ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed pointer-events-none select-none" 
                : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
            }`}
        />
    </div>
);

const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
    <div className="flex flex-col space-y-1.5 text-left">
        <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
        <textarea
            name={name}
            value={value}
            onChange={onChange}
            rows="4"
            placeholder={placeholder}
            required={required}
            className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
        />
    </div>
);

const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
    <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
        <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
            <Icon className="text-white w-4 h-4" />
        </div>
        <div className="text-left">
            <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
            <p className="text-white text-base font-bold leading-tight">{content}</p>
            {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
        </div>
    </motion.div>
);

const Whatsapp = () => {
    const navigate = useNavigate();

    // --- Form Logic: Updated Keys to fullName and phoneNumber ---
    const [formState, setFormState] = useState({ 
        fullName: '', 
        email: '', 
        phoneNumber: '', 
        subject: 'WhatsApp API Inquiry', 
        message: '' 
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [consentGiven, setConsentGiven] = useState(false); // Added consent state

    // --- CAPTCHA LOGIC ---
    const [captchaText, setCaptchaText] = useState('');
    const [userInputCaptcha, setUserInputCaptcha] = useState('');

    const generateCaptcha = () => {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
        let result = "";
        for (let i = 0; i < 6; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCaptchaText(result);
        setUserInputCaptcha('');
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'phoneNumber') {
            const cleaned = value.replace(/\D/g, ''); 
            if (cleaned.length <= 10) {
                setFormState({ ...formState, [name]: cleaned });
            }
            return;
        }
        setFormState({ ...formState, [name]: value });
    };

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;

        if (!emailRegex.test(formState.email)) {
            toast.error("Please enter a valid email address with '@'");
            return false;
        }
        if (!phoneRegex.test(formState.phoneNumber)) {
            toast.error("Phone number must be exactly 10 digits");
            return false;
        }
        if (formState.fullName.trim().length < 2) {
            toast.error("Please enter your full name");
            return false;
        }
        if (!consentGiven) { // Final check for Consent
            toast.error("Please agree to the Terms & Conditions and Privacy Policy.");
            return false;
        }
        if (userInputCaptcha.toUpperCase() !== captchaText) {
            toast.error("Incorrect security code. Please try again.");
            generateCaptcha();
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_URL}/api/public/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formState),
            });

            const result = await response.json();

            if (response.ok && result.success) {
                setIsSubmitted(true);
                toast.success(result.message || "Request sent successfully!");
                setFormState({ 
                    fullName: '', 
                    email: '', 
                    phoneNumber: '', 
                    subject: 'WhatsApp API Inquiry', 
                    message: '' 
                });
                setConsentGiven(false); // Reset consent after success
                generateCaptcha();
            } else {
                toast.error(result.message || "Something went wrong. Please try again.");
                generateCaptcha();
            }
        } catch (error) { 
            console.error(error); 
            toast.error("Failed to connect to the server.");
        } 
        finally { setIsSubmitting(false); }
    };

    const bgPuzzleStyle = {
        backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
        backgroundSize: '30px 30px',
    };

    // Features Data
    const features = [
        { title: "API Integration", description: "Easy integration with your systems.", icon: Globe, bgColor: "bg-[#00C853]", delay: 0.1 },
        { title: "Real-time Dashboard", description: "Monitor your activities in real-time.", icon: LayoutDashboard, bgColor: "bg-[#0091EA]", delay: 0.2 },
        { title: "Message Templates", description: "Create and manage message templates.", icon: MessageSquare, bgColor: "bg-[#6200EA]", delay: 0.3 },
        { title: "Bulk Messaging", description: "Send messages to multiple contacts.", icon: Zap, bgColor: "bg-[#FF6D00]", delay: 0.4 },
        { title: "CRM Features", description: "Manage customer relationships effectively.", icon: Users, bgColor: "bg-[#00BFA5]", delay: 0.5 },
        { title: "Secure Platform", description: "Built with security in mind.", icon: Shield, bgColor: "bg-[#00C853]", delay: 0.6 }
    ];

    // Integration Hub Data
    const integrationFeatures = [
        { icon: <MessageSquare className="w-5 h-5 md:w-6 md:h-6" />, title: "Auto Replies", linear: "from-blue-500 to-cyan-500", position: "left" },
        { icon: <FileText className="w-5 h-5 md:w-6 md:h-6" />, title: "Templates", linear: "from-purple-500 to-pink-500", position: "left" },
        { icon: <Settings className="w-5 h-5 md:w-6 md:h-6" />, title: "WhatsApp Config", linear: "from-green-500 to-emerald-500", position: "left" },
        { icon: <TrendingUp className="w-5 h-5 md:w-6 md:h-6" />, title: "Scale Business", linear: "from-orange-500 to-amber-500", position: "left" },
        { icon: <Send className="w-5 h-5 md:w-6 md:h-6" />, title: "Bulk Messaging", linear: "from-indigo-500 to-purple-500", position: "left" },
        { icon: <Bot className="w-5 h-5 md:w-6 md:h-6" />, title: "AI Support", linear: "from-violet-500 to-purple-500", position: "right" },
        { icon: <Clock className="w-5 h-5 md:w-6 md:h-6" />, title: "24/7 Available", linear: "from-cyan-500 to-blue-500", position: "right" },
        { icon: <Zap className="w-5 h-5 md:w-6 md:h-6" />, title: "Instant Responses", linear: "from-yellow-500 to-orange-500", position: "right" },
        { icon: <BarChart3 className="w-5 h-5 md:w-6 md:h-6" />, title: "Analytics", linear: "from-pink-500 to-rose-500", position: "right" },
        { icon: <Shield className="w-5 h-5 md:w-6 md:h-6" />, title: "Security", linear: "from-emerald-500 to-teal-500", position: "right" },
    ];

    return (
        <div className="bg-[#EEF2FC] min-h-screen font-sans overflow-x-hidden">
            <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
            
            {/* SECTION 1: HERO */}
            <div className="relative overflow-hidden">
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <motion.div
                        className="absolute -top-24 -right-24 w-[400px] h-[400px] bg-gradient-to-br from-green-400/20 via-emerald-400/15 to-teal-400/10 rounded-full blur-3xl"
                        animate={{ scale: [1, 1.1, 1], opacity: [0.3, 0.5, 0.3] }}
                        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
                    />
                </div>

                <section className="relative w-full min-h-[80vh] flex items-center overflow-hidden py-12 md:py-20 px-6">
                    <div className="max-w-[1400px] mx-auto w-full relative z-10">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
                            <div className="flex flex-col items-start text-left order-2 lg:order-1 lg:pl-16">
                                <div className="inline-block mb-6 rotate-[-2deg]">
                                    <span className="inline-flex items-center gap-2 px-4 md:px-5 py-2 bg-lime-400 border-[3px] border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] rounded-md cursor-default">
                                        <Sparkles className="w-4 h-4 text-black fill-white" />
                                        <span className="text-xs md:text-sm font-black text-black tracking-wide uppercase">
                                            Enterprise WhatsApp Business API
                                        </span>
                                    </span>
                                </div>

                                <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
                                    Turn WhatsApp into <br />
                                    <span className="relative inline-block">
                                        <span className="font-extrabold bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 bg-clip-text text-transparent">a revenue engine</span>
                                        <motion.div className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-full" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ delay: 1, duration: 0.8 }} />
                                    </span>
                                    <span className="text-slate-900"> for your business</span>
                                </h1>
                                <p className="text-lg md:text-xl text-slate-700 max-w-xl leading-relaxed mb-10">
                                    Transform customer engagement with <span className="font-bold text-slate-950">NIPANE</span>'s intelligent WhatsApp platform. AI-powered, blazing-fast, and built for enterprise.
                                </p>
                                <a 
                                    href="#contact-start" 
                                    className="inline-flex items-center gap-2 px-6 py-4 bg-slate-900 text-white text-lg font-medium rounded-xl transition-all hover:scale-105 shadow-xl active:scale-95"
                                >
                                    Start Free Trial
                                    <ChevronDown className="w-5 h-5 animate-bounce" />
                                </a>
                            </div>
                            <motion.div initial={{ opacity: 0, x: 50, scale: 0.9 }} animate={{ opacity: 1, x: 0, scale: 1 }} transition={{ duration: 1, delay: 0.3 }} className="relative order-1 lg:order-2 flex justify-center lg:justify-end">
                                <div className="absolute inset-0 bg-gradient-to-br from-green-400/20 to-emerald-400/20 rounded-2xl blur-3xl scale-110"></div>
                                <motion.div animate={{ y: [0, -15, 0] }} transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }} className="relative z-10 w-full max-w-[600px]">
                                    <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white/80">
                                        <img src={Image1} alt="WhatsApp" className="w-full h-auto object-cover" />
                                    </div>
                                </motion.div>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </div>

            {/* SECTION 2: FEATURES GRID */}
            <section className="pt-10 pb-20 px-6 bg-[#EEF2FC]">
                <div className="max-w-[1200px] mx-auto text-center">
                    <div className="mb-16">
                        <h2 className="text-3xl md:text-5xl font-semibold text-slate-900 mb-4">
                            Powerful{" "}
                            <span className="relative inline-block">
                                <span className="text-emerald-600">features</span>
                                <motion.div className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-full" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={{ delay: 0.4, duration: 0.8 }} />
                            </span>
                        </h2>
                        <p className="text-slate-700 text-lg md:text-xl font-medium">Everything you need to manage WhatsApp business communications</p>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
                        {features.map((feature, index) => (
                            <motion.div key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: feature.delay }} className="group relative p-8 rounded-[2rem] bg-[#D0DCF2] border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden">
                                <div className={`w-14 h-14 rounded-2xl ${feature.bgColor} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}><feature.icon className="w-7 h-7 text-white" /></div>
                                <h3 className="text-2xl font-bold text-slate-900 mb-3 leading-tight">{feature.title}</h3>
                                <p className="text-slate-600 text-base leading-relaxed">{feature.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* SECTION 3: INTEGRATION HUB */}
            <section className="py-12 px-6 bg-[#EEF2FC] relative overflow-hidden">
                <div className="max-w-[1400px] mx-auto relative z-10">
                    <div className="text-center mb-16 px-4">
                        <h2 className="text-3xl md:text-5xl font-semibold text-slate-900 mb-4 tracking-tight">
                            Everything you need,{" "}
                            <span className="relative inline-block">
                                <span className="bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">all in one place</span>
                                <motion.div className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-full" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={{ delay: 0.4, duration: 0.8 }} />
                            </span>
                        </h2>
                        <p className="text-slate-600 text-lg md:text-xl font-normal max-w-2xl mx-auto">NIPANE connects all your WhatsApp business tools seamlessly into a single ecosystem.</p>
                    </div>

                    <div className="relative min-h-[500px] lg:min-h-[600px] flex items-center justify-center">
                        <motion.div initial={{ scale: 0 }} whileInView={{ scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8, type: "spring" }} className="relative z-20">
                            <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-emerald-500 rounded-3xl blur-2xl opacity-40" />
                            <motion.div className="relative bg-gradient-to-br from-green-500 to-emerald-600 rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-white" whileHover={{ scale: 1.05 }}>
                                <MessageSquare className="w-10 h-10 md:w-16 md:h-16 text-white mx-auto mb-4" />
                                <h3 className="text-2xl md:text-4xl font-black text-white text-center tracking-tighter">NIPANE</h3>
                            </motion.div>
                            
                            {[1, 2, 3].map((ring, idx) => (
                                <motion.div key={ring} className="absolute inset-0 border-2 border-green-400 rounded-3xl" animate={{ scale: [1, 1.3 + idx * 0.2, 1], opacity: [0.6, 0, 0.6] }} transition={{ duration: 4, repeat: Infinity, delay: idx * 0.5, ease: "easeOut" }} />
                            ))}
                        </motion.div>

                        <div className="hidden lg:block absolute inset-0 w-full h-full">
                            <div className="absolute left-[12%] top-1/2 -translate-y-1/2 space-y-6">
                                {integrationFeatures.filter(f => f.position === "left").map((feature, idx) => (
                                    <motion.div key={idx} initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }} whileHover={{ scale: 1.05, x: 10 }} className="flex items-center gap-4 bg-white p-4 rounded-2xl shadow-xl border border-slate-100 min-w-[260px] group cursor-default">
                                        <div className={`p-3 rounded-xl bg-gradient-to-br ${feature.linear} text-white shadow-lg transition-transform group-hover:rotate-12`}>{feature.icon}</div>
                                        <h4 className="font-bold text-slate-800 text-lg">{feature.title}</h4>
                                    </motion.div>
                                ))}
                            </div>
                            <div className="absolute right-[12%] top-1/2 -translate-y-1/2 space-y-6">
                                {integrationFeatures.filter(f => f.position === "right").map((feature, idx) => (
                                    <motion.div key={idx} initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }} whileHover={{ scale: 1.05, x: -10 }} className="flex items-center gap-4 bg-white p-4 rounded-2xl shadow-xl border border-slate-100 min-w-[260px] group cursor-default">
                                        <div className={`p-3 rounded-xl bg-gradient-to-br ${feature.linear} text-white shadow-lg transition-transform group-hover:-rotate-12`}>{feature.icon}</div>
                                        <h4 className="font-bold text-slate-800 text-lg">{feature.title}</h4>
                                    </motion.div>
                                ))}
                            </div>
                        </div>

                        <div className="lg:hidden grid grid-cols-1 sm:grid-cols-2 gap-4 mt-20 w-full max-w-2xl">
                            {integrationFeatures.map((feature, idx) => (
                                <motion.div key={idx} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-md border border-slate-100">
                                    <div className={`p-2 rounded-lg bg-gradient-to-br ${feature.linear} text-white shadow-sm`}>{feature.icon}</div>
                                    <span className="font-bold text-slate-800 text-sm">{feature.title}</span>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* REQUEST A DEMO SECTION */}
            <section id="contact-start" className="py-16 relative overflow-hidden">
                <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
                <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
                
                <div className="container mx-auto px-4 relative z-10">
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
                        {/* LEFT SIDE */}
                        <motion.div variants={itemVariants} className="space-y-8">
                            <div>
                                <div className="inline-flex items-center gap-2 mb-2">
                                    <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
                                    <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">Get in Touch</span>
                                </div>
                                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">Request a <span className="text-[#F46653]"> WhatsApp Demo</span></h2>
                                <p className="text-white/70 text-base leading-relaxed text-left">Our dedicated support team is available 24/7 to assist with your business communication needs.</p>
                            </div>

                            <div className="space-y-3">
                                <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
                                <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
                                <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
                                <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
                            </div>

                            <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
                                <p className="text-white text-base font-bold mb-2 text-left">Connect With Us -</p>
                                <div className="flex gap-3">
                                    {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
                                        <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white group transition-all">
                                            <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
                                        </motion.a>
                                    ))}
                                </div>
                            </motion.div>
                        </motion.div>

                        {/* RIGHT SIDE - FORM */}
                        <motion.div variants={itemVariants}>
                            <div className="bg-white rounded-3xl shadow-2xl p-8">
                                <AnimatePresence mode="wait">
                                    {isSubmitted ? (
                                        <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-12">
                                            <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
                                            <h3 className="text-3xl font-bold text-gray-800 mb-4">Request Sent!</h3>
                                            <p className="text-gray-600 mb-8">Our team will get back to you within 2 hours to schedule your demo.</p>
                                            <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl hover:bg-[#09333c] transition-colors">Send Another</button>
                                        </motion.div>
                                    ) : (
                                        <motion.div key="form">
                                            <div className="flex items-center gap-3 mb-6">
                                                <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
                                                <div className="text-left">
                                                    <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
                                                    <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
                                                </div>
                                            </div>
                                            <form onSubmit={handleSubmit} className="space-y-5">
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                                    <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
                                                    <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
                                                </div>
                                                
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                                    <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
                                                    <InputField 
                                                        label="Subject" 
                                                        name="subject" 
                                                        value="WhatsApp API Inquiry" 
                                                        readOnly={true} 
                                                    />
                                                </div>

                                                <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

                                                {/* --- ADDED CAPTCHA FIELD --- */}
                                                <div className="flex flex-col space-y-1.5 pt-2 text-left">
                                                    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
                                                    <div className="flex items-center gap-4">
                                                        <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
                                                            <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
                                                                {captchaText}
                                                            </span>
                                                        </div>
                                                        <button 
                                                            type="button" 
                                                            onClick={generateCaptcha} 
                                                            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                                                            title="Refresh Code"
                                                        >
                                                            <RefreshCcw className="w-5 h-5 text-gray-500" />
                                                        </button>
                                                        <div className="flex-1">
                                                            <input
                                                                type="text"
                                                                placeholder="Enter code"
                                                                value={userInputCaptcha}
                                                                onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
                                                                className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* --- CONSENT CHECKBOX --- */}
                                                <div className="flex items-start gap-3 pt-2 text-left">
                                                    <input
                                                        type="checkbox"
                                                        id="consent"
                                                        checked={consentGiven}
                                                        onChange={(e) => setConsentGiven(e.target.checked)}
                                                        className="mt-1 min-w-[1rem] w-4 h-4 text-[#0C4550] border-gray-300 rounded focus:ring-[#0C4550] cursor-pointer"
                                                        required
                                                    />
                                                    <label htmlFor="consent" className="text-sm text-gray-600 leading-relaxed cursor-pointer select-none">
                                                        I agree to the <Link to="/terms-and-conditions" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Terms & Conditions</Link> and <Link to="/privacy-policy" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Privacy Policy</Link> and consent to receive communications from <strong>Deetya Soft Private Limited</strong> via SMS, Email, Calls, RCS Messages, and WhatsApp.
                                                    </label>
                                                </div>

                                                <div className="flex items-center justify-between pt-2">
                                                    <motion.button 
                                                        disabled={isSubmitting || userInputCaptcha.length < 6 || !consentGiven} 
                                                        whileHover={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 1.02 }} 
                                                        whileTap={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 0.98 }} 
                                                        type="submit" 
                                                        className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                                                    >
                                                        {isSubmitting ? (
                                                            <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
                                                        ) : (
                                                            <>Send Message <Send className="w-5 h-5" /></>
                                                        )}
                                                    </motion.button>
                                                </div>
                                            </form>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default Whatsapp;